<footer>
  <div class="bg-hyundai-grey text-white py-[45px]">
    <div class="container mx-auto">
      <div class="top-section flex flex-col xl:flex-row border-b-2 border-[#474747] pl-4 md:pl-0">
        <div class="logo w-1/6 text-4xl my-8">
        </div>

      </div>
      <div class="socials border-b-2 border-[#474747]">
        <ul class="flex gap-5 py-10 ">
          <li class="socials_list_item ">
            <a href="https://www.facebook.com/hyundai.hungary" target="_blank" class="list__link">
              <i class="list__item-icon is-font-icon-footer_fb"></i>
            </a>
          </li>
          <li class="socials_list_item">
            <a href="https://www.youtube.com/user/HyundaiHungary" target="_blank" class="list__link">
              <i class="list__item-icon is-font-icon-footer_yt"></i>
            </a>
          </li>
          <li class="socials_list_item">
            <a href="https://www.linkedin.com/company/hyundai-hungary/" target="_blank" class="list__link">
              <i class="list__item-icon is-font-icon-footer_li"></i>
            </a>
          </li>
          <li class="socials_list_item">
            <a href="https://www.instagram.com/hyundai_hun/" target="_blank" class="list__link">
              <i class="list__item-icon is-font-icon-footer_ig"></i>
            </a>
          </li>
        </ul>
      </div>
      <div class="copyright text-[14px] my-10 md:mb-0 text-center md:text-left">
        <p>Ⓒ 2025 Hyundai Magyarország
        </p>
      </div>
      <div class="misc-links text-[14px]">
        <div class="flex justify-center md:justify-end gap-4">

          <li class="nav-item list-none leading-tight pb-2 ml-2 lg:ml-0">
            <a class="hover:underline" href="https://hyundai.hu/jogi-nyilatkozat/">Jogi nyilatkozat</a>
          </li>


          <li class="nav-item list-none leading-tight pb-2 ml-2 lg:ml-0">
            <a class="hover:underline" href="https://hyundai.hu/adatvedelem/">Adatvédelem</a>
          </li>


          <li class="nav-item list-none leading-tight pb-2 ml-2 lg:ml-0">
            <a class="hover:underline" href="https://hyundai.hu/suti-iranyelv/">Süti irányelvek</a>
          </li>

        </div>
      </div>
    </div>
  </div>
</footer>
